<div class="wms-spinner-container">
    <div class="wms-spinner-overlay"></div>
    <div class="wms-spinner {{spinnerType.class}}">
        <div class="loader">
            <i class="wms wms-logo"></i>
            <svg class="circular">
                <circle class="path" cx="50" cy="50" [attr.r]="spinnerType.radius" fill="none" stroke-miterlimit="10"/>
            </svg>
        </div>
        <p *ngIf="caption" class="wms-spinner-caption">{{caption}}</p>
    </div>
</div>
